export default function XIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9998 13.4L9.0998 16.3C8.91647 16.4833 8.68314 16.575 8.3998 16.575C8.11647 16.575 7.88314 16.4833 7.6998 16.3C7.51647 16.1166 7.4248 15.8833 7.4248 15.6C7.4248 15.3166 7.51647 15.0833 7.6998 14.9L10.5998 12L7.6998 9.12495C7.51647 8.94162 7.4248 8.70828 7.4248 8.42495C7.4248 8.14162 7.51647 7.90828 7.6998 7.72495C7.88314 7.54162 8.11647 7.44995 8.3998 7.44995C8.68314 7.44995 8.91647 7.54162 9.0998 7.72495L11.9998 10.625L14.8748 7.72495C15.0581 7.54162 15.2915 7.44995 15.5748 7.44995C15.8581 7.44995 16.0915 7.54162 16.2748 7.72495C16.4748 7.92495 16.5748 8.16262 16.5748 8.43795C16.5748 8.71328 16.4748 8.94228 16.2748 9.12495L13.3748 12L16.2748 14.9C16.4581 15.0833 16.5498 15.3166 16.5498 15.6C16.5498 15.8833 16.4581 16.1166 16.2748 16.3C16.0748 16.5 15.8375 16.6 15.5628 16.6C15.2881 16.6 15.0588 16.5 14.8748 16.3L11.9998 13.4Z"
        fill="white"
      />
    </svg>
  );
}
